"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CameraIcon = function CameraIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "quiver-camera-icon", viewBox: "0 0 12 8", preserveAspectRatio: "xMinYMin meet" },
    _react2.default.createElement("rect", { x: "0", y: "0", width: "9", height: "8", rx: "1", ry: "1" }),
    _react2.default.createElement("polygon", { points: "9,5 9,3 12,1 12,7" })
  );
};

exports.default = CameraIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CameraIcon/CameraIcon.js
// module id = 549
// module chunks = 11